export const usersManualPhoneVerificationUrl = '/users/phone-verification/';

export const loginUrl = '/login/';
export const signupIFrameSimpleUrl = '/signup/iframe/simple/';
export const signupUrl = '/signup/';

export const formsGalleryUrl = '/forms-gallery/';
